module.exports = __webpack_public_path__ + "static/img/50.18daa1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s32/pop/50.png
// module id = D1Sw
// module chunks = 2